import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=568a587f&scoped=true&"
import script from "./PasswordReset.vue?vue&type=script&lang=js&"
export * from "./PasswordReset.vue?vue&type=script&lang=js&"
import style0 from "./PasswordReset.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PasswordReset.vue?vue&type=style&index=1&id=568a587f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568a587f",
  null
  
)

export default component.exports